module.exports = __webpack_public_path__ + "static/media/sb.54215c8c.svg";